   <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="data.isProfile">{{ 'Profile.UpdateMyProfile' | translate }}</h4>
        <h4 class="modal-title" *ngIf="!updateUser && !data.isProfile">{{ 'users.CreateUser' | translate }}</h4>
        <h4 class="modal-title" *ngIf="updateUser && !data.isProfile">{{ 'users.UpdateUser' | translate }} "{{ userDetails?.name }}"
        </h4>
        <button type="button" class="close" aria-label="Close" mat-dialog-close>
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body" id="formModalBody">
        <form [formGroup]="addUserForm" #form="ngForm">
          <section class="card gray-card">
            <div class="fraction-pagination">
              <div class="pagination-circle">
                <span class="activeNum">1/</span><span>3</span>
              </div>
              <span class="pagination-title">{{ 'register.personalTab' | translate }}</span>
            </div>
            <div class="form-elements">
              <div class="form-group">
                <mat-form-field>
                  <mat-label> {{ 'users.FullName' | translate }}</mat-label>
                  <input matInput placeholder="" (keyup)="makeBudge($event)" value="" formControlName="fullnameControl"
                    maxlength="50">
                  <mat-error *ngIf="hasError('fullnameControl', 'required')">
                    {{ 'messages.fullNameMsg' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('fullnameControl', 'pattern')">
                    {{ 'messages.vaildFullName' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="form-group">
                <div class="budge-control">
                  <label for="budge-file" class="budge-container">
                    <input type="file" name="" [(ngModel)]="fileInputValue" [ngModelOptions]="{standalone: true}"
                      id="budge-file" multiple #fileInput (change)="addFile($event)">
                    <span class="icon">
                      <svg width="10" height="10" viewBox="0 0 10 10">
                        <path id="plus-icon"
                          d="M9.318,4.091H5.909V.682A.682.682,0,0,0,5.227,0H4.773a.682.682,0,0,0-.682.682V4.091H.682A.682.682,0,0,0,0,4.773v.455a.682.682,0,0,0,.682.682H4.091V9.318A.682.682,0,0,0,4.773,10h.455a.682.682,0,0,0,.682-.682V5.909H9.318A.682.682,0,0,0,10,5.227V4.773A.682.682,0,0,0,9.318,4.091Zm0,0"
                          fill="#fff" />
                      </svg>
                    </span>
                    <span class="img-container">
                      <span *ngIf="!imageSrc">{{ budge }}</span>
                      <img [src]="imageSrc" *ngIf="imageSrc">
                    </span>
                  </label>
                  <div class="msg">
                    {{ 'users.UserBadge' | translate }}
                  </div>
                </div>
              </div>
              <div class="form-group">
                <mat-form-field>
                  <mat-label>{{ 'fields.arbicName' | translate }}</mat-label>
                  <input matInput placeholder="" value="" formControlName="nameControl" required maxlength="50">
                  <mat-error *ngIf="hasError('nameControl', 'required')">
                    {{ 'messages.arbicPatternMsg' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('nameControl', 'minlength')">
                    {{ 'users.nameMustBe' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('nameControl', 'pattern')">
                    {{ 'messages.arbicPatternMsg' | translate }}
                  </mat-error>

                </mat-form-field>
              </div>

              <div class="mb-3 form-group" *ngIf="addUserForm.controls.userTypeEnum.value !== userTypeEnum.Member">
                <label class="mb-3">{{ 'fields.userType' | translate }}:</label>
                <mat-radio-group formControlName="userTypeEnum">
                  <div class="row">
                    <div class="col-6">
                      <mat-radio-button [value]="userTypeEnum.InternalUser">{{ 'fields.internal' | translate
                        }}</mat-radio-button>
                    </div>
                    <div class="col-6">
                      <mat-radio-button [value]="userTypeEnum.Ambassador">{{ 'fields.ambassador' | translate
                        }}</mat-radio-button>
                    </div>
                  </div>
                </mat-radio-group>
                <!-- <mat-error *ngIf="addUserForm.controls.userType.hasError('required')">
                                  please choose userType!
                              </mat-error> -->
              </div>

              <!-- Date Picker -->
              <div class="form-group">
                <mat-form-field>
                  <mat-label>{{ 'fields.dateBirth' | translate }}</mat-label>
                  <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="picker" formControlName="dateOfBirth"
                    [(ngModel)]="date" readonly>
                  <mat-icon matDatepickerToggleIcon (click)="clearDate($event)">clear</mat-icon>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="hasError('dateOfBirth', 'required')">{{ 'users.PleaseDate' | translate
                    }}</mat-error>
                  <mat-error *ngIf="hasError('dateOfBirth', 'matDatepickerMax')">{{ 'messages.dateInferior' | translate
                    }}</mat-error>
                </mat-form-field>
              </div>

              <div class="form-group">
                <mat-form-field>
                  <mat-label>{{ 'fields.Identification Number' | translate }}</mat-label>
                  <input matInput type="text" maxlength="50" formControlName="identityNumber" required>
                  <mat-error *ngIf="hasError('identityNumber', 'required')">{{ 'messages.required' | translate
                    }}</mat-error>
                </mat-form-field>
              </div>

              <div class="form-group">
                <label class="mb-3">{{ 'fields.gender' | translate }}:</label>
                <mat-radio-group formControlName="gender">
                  <div class="row">
                    <div class="col-6">
                      <mat-radio-button value="m">{{ 'fields.male' | translate }}</mat-radio-button>
                    </div>
                    <div class="col-6">
                      <mat-radio-button value="f">{{ 'fields.female' | translate }}</mat-radio-button>
                    </div>
                  </div>
                </mat-radio-group>
                <!-- <mat-error *ngIf="gender.hasError('required')">
                                  please choose gender!
                              </mat-error> -->
              </div>
              <!-- <div  class="form-group" *ngIf="visitorCheck.visible">
                            <div class="statistics">
                              <div>
                                <div class="d-flex align-items-center">
                                    <label class="m-0"> {{ 'fields.Is Visitor' | translate }}</label>
                                    <div class="ml-auto mt-1">
                                        <mat-slide-toggle formControlName="isVisitor" [disabled]="visitorCheck.required"></mat-slide-toggle>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
            </div>
          </section>

          <section class="card gray-card">
            <div class="fraction-pagination">
              <div class="pagination-circle">
                <span class="activeNum">2/</span><span>3</span>
              </div>
              <span class="pagination-title">{{ 'register.accountTab' | translate }}</span>
            </div>
            <div class="form-elements">
              <div class="form-group">
                <!-- emailmodelChanged($event, userID) -->
                <mat-form-field>
                  <mat-label> {{ 'fields.email' | translate }}</mat-label>
                  <input matInput formControlName="emailControl" placeholder="Ex. pat@example.com"
                    (ngModelChange)="emailmodelChanged($event)" [disabled]='updateUser' maxlength="50">
                  <mat-error *ngIf="hasError('emailControl', 'required')">
                    {{ 'users.PleaseEmail' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('emailControl', 'pattern') && !hasError('emailControl', 'required')">
                    {{ 'messages.invalidEmail' | translate }}
                  </mat-error>
                </mat-form-field>
                <div class="has-error" [hidden]="!emailnameexist">
                  {{ 'messages.uniqeEmail' | translate }}
                </div>
              </div>
              <div class="form-group">
                <mat-form-field>
                  <mat-label>{{ 'fields.userName' | translate }}</mat-label>
                  <input matInput type="text" formControlName="userName" id="userName"
                    (ngModelChange)="userNamemodelChanged($event)" [disabled]='updateUser' maxlength="20">
                  <mat-error *ngIf="hasError('userName', 'required')">
                    {{ 'messages.requeirUserName' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('userName', 'pattern')">
                    {{ 'messages.invalidUserName' | translate }}
                  </mat-error>
                  <mat-error *ngIf="hasError('userName', 'minlength')">
                    {{ 'users.nameMustBe4' | translate }}
                  </mat-error>
                </mat-form-field>
                <div class="has-error" [hidden]="!usernameexist">
                  {{ 'messages.uniqeUsername' | translate }}
                </div>
                <!-- <div class="has-error" *ngIf="usernameNumberOnly">
                                  you can't enter numbers or special character only!
                              </div>  -->
              </div>
            </div>
          </section>

          <section class="card gray-card">
            <div class="fraction-pagination">
              <div class="pagination-circle">
                <span class="activeNum">3/</span><span>3</span>
              </div>
              <span class="pagination-title">{{ 'register.contactTab' | translate }}</span>
            </div>
            <div class="form-elements">


              <!-- <div class="form-group">
                              <mat-form-field>
                                  <mat-label>{{ 'users.Nationality' | translate }}</mat-label>
                                  <mat-select formControlName="NationalitiesControl">
                                      <mat-option *ngFor="let Nationality of Nationalities" [value]="Nationality.id"> {{Nationality.name}} </mat-option>
                                  </mat-select>
                                  <mat-error *ngIf="hasError('NationalitiesControl', 'required')">{{ 'users.chooseNationality' | translate }}</mat-error>
                              </mat-form-field>
                          </div> -->

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>{{ 'fields.country' | translate }}</mat-label>
                      <mat-select formControlName="countryControl" (selectionChange)="getCitiesId($event)">
                        <mat-option> </mat-option>
                        <mat-option *ngFor="let country of countries" [value]="country.id"> {{country.name}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="hasError('countryControl', 'required')">{{ 'messages.requeirCountry' | translate
                        }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>{{ 'fields.city' | translate }}</mat-label>
                      <mat-select formControlName="cityControl" [disabled]="!enableCity">
                        <mat-option> </mat-option>
                        <mat-option *ngFor="let city of cities" [value]="city.id">
                          {{city.name}}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="hasError('cityControl', 'required')">{{ 'messages.requeirCity' | translate
                        }}</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label> {{ 'users.CountryCode' | translate }} </mat-label>
                      <input matInput placeholder="" [(ngModel)]="countryKey" readonly type="text"
                        [ngModelOptions]="{standalone: true}">
                      <!-- <mat-error *ngIf="hasError('extentionControl', 'required')">
                                              please enter Country code!
                                          </mat-error>

                                          <mat-error *ngIf="hasError('extentionControl', 'pattern')">
                                              please enter vaild Country code!
                                          </mat-error> -->
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <mat-form-field>
                      <mat-label>{{ 'fields.phoneNumber' | translate }}</mat-label>
                      <input type="text" placeholder="" value="" matInput placeholder=""
                        formControlName="phoneNumberControl" maxlength="12">
                      <mat-error *ngIf="hasError('phoneNumberControl', 'required')">
                        {{ 'messages.requeirphone' | translate }}
                      </mat-error>
                      <mat-error *ngIf="hasError('phoneNumberControl', 'pattern')">
                        {{ 'messages.invalidphone' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>

            </div>
          </section>

          <!-- <section class="card gray-card">
                      <div class="fraction-pagination">
                          <div class="pagination-circle">
                              <span class="activeNum">4/</span><span>3</span>
                          </div>
                          <span class="pagination-title">{{ 'register.jobTab' | translate }}</span>
                      </div>
                      <div class="form-elements">
                          <div class="form-group">
                              <mat-form-field>
                                  <mat-label>  {{ 'fields.job' | translate }}</mat-label>
                                  <input matInput placeholder="" value="" formControlName="jobTitleControl" maxlength="30">
                                  <mat-error *ngIf="hasError('jobTitleControl', 'required')">
                                        {{ 'messages.requeirJob' | translate }}
                                  </mat-error>
                              </mat-form-field>
                          </div>
                          <div class="form-group">
                              <mat-form-field>
                                  <mat-label>{{ 'fields.employer' | translate }}</mat-label>
                                  <input matInput placeholder="" value="" formControlName="employer" maxlength="30">
                                  <mat-error *ngIf="hasError('employer', 'required')">
                                      {{ 'messages.requeirEmployer' | translate }}
                                  </mat-error>

                              </mat-form-field>
                          </div>
                          <div class="form-group">
                              <mat-form-field>
                                  <mat-label>{{ 'users.workLocation' | translate }}</mat-label>
                                  <input matInput placeholder="" value="" formControlName="workLocationControl" maxlength="50">
                                  <mat-error *ngIf="hasError('workLocationControl', 'required')">
                                      {{ 'users.enterWorkLocation' | translate }}
                                  </mat-error>
                              </mat-form-field>
                          </div>
                      </div>
                  </section> -->

          <div class="modal-btns">

            <button type="button" class="close closebtn" mat-dialog-close>
              <span>{{ 'users.Cancel' | translate }}</span>
            </button>
            <button mat-raised-button class="btn customBtn" (click)="saveUser()" [ngClass]="{ 'loading': loading}">
              <span *ngIf="updateUser && !data.isProfile">{{ 'users.UpdateUser' | translate }}</span>
              <span *ngIf="data.isProfile">{{ 'group.save' | translate }}</span>
              <span *ngIf="!updateUser">{{ 'users.addUser' | translate }}</span>
            </button>

          </div>
        </form>
      </div>
    </div>
  </div>
